import { render, staticRenderFns } from "./integracoes-painel.vue?vue&type=template&id=4b85281e&scoped=true&"
import script from "./integracoes-painel.vue?vue&type=script&lang=js&"
export * from "./integracoes-painel.vue?vue&type=script&lang=js&"
import style0 from "./integracoes-painel.vue?vue&type=style&index=0&id=4b85281e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b85281e",
  null
  
)

export default component.exports